import earcut from "earcut";
import { GLMesh } from "./scene/mesh.js";
import { GLEngineResources } from "./engineResources.js";

export class Selection {
    _resources: GLEngineResources;
    _active: boolean;
    _line: GLMesh;
    _polygon: GLMesh;
    _currentIndex: number;
    _mode: number;
    _framebuffer: any;
    _renderbuffer: any;

    constructor(resources) {
        var self = this;
        var gl = resources.gl;
        self._resources = resources;
        self._active = false;
        self._line = new GLMesh(gl);
        self._line.primitives = gl.LINE_LOOP;
        self._polygon = new GLMesh(gl);
        self._currentIndex = 0;
        self._mode = 0; // 0 polygon - 1 square

        self._framebuffer = gl.createFramebuffer();
        self._renderbuffer = gl.createRenderbuffer();

        gl.bindRenderbuffer(gl.RENDERBUFFER, self._renderbuffer);
        gl.bindFramebuffer(gl.FRAMEBUFFER, self._framebuffer);
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, self._renderbuffer);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindRenderbuffer(gl.RENDERBUFFER, null);
    }

    resize() {
        var self = this;
        var gl = self._resources.gl;
        gl.bindRenderbuffer(gl.RENDERBUFFER, self._renderbuffer);
        gl.renderbufferStorageMultisample(gl.RENDERBUFFER, 4, gl.RGBA8, self._resources.width, self._resources.height);
        gl.bindRenderbuffer(gl.RENDERBUFFER, null);
    }

    get framebuffer() {
        return this._resources.drawbuffer;
    }

    get target() {
        return this._resources.drawtarget;
    }

    render() {
        var self = this;
        var gl = self._resources.gl;
        var program = self._resources.programs['selection'];
        gl.viewport(0, 0, self._resources.width, self._resources.height);
        gl.bindRenderbuffer(gl.RENDERBUFFER, self._renderbuffer);
        gl.bindFramebuffer(gl.FRAMEBUFFER, self._framebuffer);
        gl.clearBufferfv(gl.COLOR, 0, [0.0, 0.0, 0.0, 0.0]);
        program.use();
        self._triangulate();
        this._polygon.bind(program);
        this._polygon.draw();
        this._polygon.unbind(program);
        program.unuse();
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindRenderbuffer(gl.RENDERBUFFER, null);

        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, self._framebuffer);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, self._resources.drawbuffer);
        gl.clearBufferfv(gl.COLOR, 0, [0.0, 0.0, 0.0, 0.0]);
        gl.blitFramebuffer(0, 0, self._resources.width, self._resources.height, 0, 0, self._resources.width, self._resources.height, gl.COLOR_BUFFER_BIT, gl.NEAREST);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
    }

    destroy() {
        var self = this;
        var gl = self._resources.gl;
        self._line.destroy();
        self._polygon.destroy();
        gl.deleteRenderbuffer(self._renderbuffer);
        gl.deleteFramebuffer(self._framebuffer);
    }

    get activated() {
        return this._active;
    }

    set active(value) {
        this._active = value;
    }

    get hasSelection() {
        return this._currentIndex > 0;
    }

    get mode() {
        return this._mode;
    }

    set mode(value) {
        this._mode = value;
    }

    addPoint(point) {
        var self = this;
        switch (self._mode) {
            case 0:
                self._line.addVertice(point[0], point[1]);
                self._line.addIndex(self._currentIndex++);
                if (self._currentIndex === 1) {
                    self._line.addVertice(point[0], point[1]);
                    self._line.addIndex(self._currentIndex++);
                }
                break;
            case 1:
                if (self._currentIndex !== 0) {
                    self.clear();
                }
                for (var i = 0; i < 4; ++i) {
                    self._line.addVertice(point[0], point[1]);
                    self._line.addIndex(self._currentIndex++);
                }
                break;
        }
    }

    movePoint(point) {
        var self = this;
        switch (self._mode) {
            case 0:
                self._line.moveVertice(point[0], point[1], (self._currentIndex * 3) - 1);
                break;
            case 1:
                self._line.moveVertice(point[0], self._line.getVertice(((self._currentIndex - 2) * 3) - 1).y, ((self._currentIndex - 2) * 3) - 1);
                self._line.moveVertice(point[0], point[1], ((self._currentIndex - 1) * 3) - 1);
                self._line.moveVertice(self._line.getVertice((self._currentIndex * 3) - 1).x, point[1], (self._currentIndex * 3) - 1);
                break;
        }
    }

    clear() {
        var self = this;
        self._currentIndex = 0;
        self._line.clear();
    }

    bindLine(program) {
        this._line.bind(program);
    }

    drawLine() {
        var self = this;
        self._line.draw();
    }

    unbindLine(program) {
        this._line.unbind(program);
    }

    _triangulate() {
        var self = this;
        var indices = earcut(self._line._vertices, undefined, 3);
        self._polygon._vertices = self._line._vertices;
        self._polygon._indexes = indices;
        self._polygon.rebuild();
    }

}
